<template>
<div class="cardPay">
  <div>
    <div class="head">
      <span class="s-16">金额(¥)</span>
      <input type="text" placeholder="请输入充值金额" name="" v-model="payMoney" readonly>
    </div>
  </div>
  <div class="pay" v-show="payType == 'weixin' || payType == 'alipay'">
    <h1>支付方式</h1>
    <ul>
      <li v-show="payType == 'weixin'">
        <img class="fl" src="../../images/icon/wx.png">
        微信
        <img class="fr" src="../../images/icon/check1.png">
      </li>
      <li v-show="payType == 'alipay'">
        <img class="fl" src="../../images/icon/zfb.png">
        支付宝
        <img class="fr" src="../../images/icon/check1.png">
      </li>
    </ul>
  </div>
  <div class="cardBut" v-if="payType != 3">
    <span class="active" @click="pay">确认支付 <font v-if="getdatanull(payMoney)">¥{{payMoney}}</font></span>
  </div>
  <div class="popups" v-show="landingShow">
    <div class="mask">
      <div class="landing">
        <h2>绑定手机号</h2>
        <div class="msgs">
          <div class="text-enter">
            <div class="landedText username">
              <input @blur="fixScroll" name="username" placeholder="请输入手机号" type="text" v-model="phone">
            </div>
            <div class="landedText password">
              <input @blur="fixScroll" type="password" name="password" placeholder="验证码" v-model="authCode">
              <span class="pas-but" @click="codeSendMes()" v-if="but">获取验证码</span>
              <span class="pas-but" v-else>{{timerCodeMsg}}</span>
            </div>
          </div>
        </div>
        <div class="but clearfix">
          <ul>
            <li @click="cancel()">取消</li>
            <li class="red" @click="submit()">确定</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import api from '@/fetch/api'
export default {
  name: 'cardBuy',
  data () {
    return {
      payType: '',
      landingShow:false,
      timerCodeMsg: '', //点击获取验证码
      phone: '', //手机号码
      authCode: '', //验证码
      but: true, //验证码按钮
      payMoney:this.$route.query.payMoney
    }
  },
  created() {
    this.getPayWay()
  },
  methods: {
    fixScroll() {  //兼容微信 页面上划
      window.scrollTo(0, 0);
    },
    getPayWay() {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信浏览器
        this.payType = 'weixin';

      } else if(ua.match(/alipay/i) == "alipay") {
        //支付宝浏览器
        this.payType = 'alipay';

      } else {
        this.payType = 3;
        this.$messagebox.alert('请使用微信或支付宝打开','提示')
      }

    },
    pay(){ //购买
      this.$indicator.open();
      if(this.$route.query.type == 'count'){
        let data = {
          countOrderNo:this.$route.query.orderNo,
          loginShopAlias:this.$route.query.shopAlias,
          payType:this.payType,
          payMoney:this.$route.query.payMoney
        }
        api.countNumCardPrePay(data)
        .then(res => {
          this.$indicator.close();
          this.goOrderPay(this.payType,res)
        }, res => {
          this.$indicator.close();
          this.$toast(res.resultMsg);
        })
      }else{
        let data = {
          discountOrderNo:this.$route.query.orderNo,
          loginShopAlias:this.$route.query.shopAlias,
          payType:this.payType,
          payMoney:this.$route.query.payMoney
        }
        api.discountCardPrePay(data)
        .then(res => {
          this.$indicator.close();
          this.goOrderPay(this.payType,res)
        }, res => {
          this.$indicator.close();
          this.$toast(res.resultMsg);
        })
      }

    },
    cancel(){
      landingShow=false;
      this.$router.go(-1)
    },
    codeSendMes() { //请求验证码
				let reg = /^1\d{10}$/;
				if(this.phone == '') {
					this.$toast({
						message: '请输入手机号码',
						position: 'bottom',
						duration: 2000
					});
				} else if(!reg.test(this.phone)) {
					this.$toast({
						message: '手机格式不正确',
						position: 'bottom',
						duration: 2000
					});
				} else {
					this.but = false;
					let sec = 60;
					let _this = this;
					for(let i = 0; i <= 60; i++) {
						window.setTimeout(function() {
							if(sec != 0) {
								_this.timerCodeMsg = sec + "秒";
								sec--;
							} else {
								sec = 60; //如果倒计时结束就让  获取验证码显示出来
								_this.but = true;
							}
						}, i * 1000)
          }
          let data = {
            phone:this.phone,
            sceneCode:'memberLogin'
          }
					api.phonemethods(data).then(res => {
						return
					}, res => {
						this.but = true;
						this.$toast({
							message: res.resultMsg,
							position: 'bottom',
							duration: 2000
						});
					});
				}
      },
      submit() { //成为会员
				let reg = /^1\d{10}$/;
				if(this.phone == '') {
					this.$toast({
						message: '请输入手机号码',
						position: 'bottom',
						duration: 2000
					});
				} else if(!reg.test(this.phone)) {
					this.$toast({
						message: '手机格式不正确',
						position: 'bottom',
						duration: 2000
					});
				} else if(this.authCode == '') {
					this.$toast({
						message: '请输入验证码',
						position: 'bottom',
						duration: 2000
					});

				} else {

					//if(!localStorage.token) {
          let data = {
            "newPhone": this.phone,
            "authCode": this.authCode
          }
					api.combineWithPhone(data)
						.then(res => {
              this.landingShow = false
              this.init()
						}, res => {
							this.$toast({
								message: res.resultMsg,
								position: 'bottom',
								duration: 2000
							});
						})
					//}
					// api.addshopcashier(this.loginShopAlias,this.phone,this.authCode);
				}
      },

  },
   watch: {
      '$route': function () {
      	this.init();
      },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/pay/cardbuy.vue